<template>
  <label :for="csvFile"
    >{{ label }}
    <a v-if="infolink" :href="infolink" target="_blank" class="infolink"> ?</a>
  </label>
  <Dropdown
    v-model="input"
    :options="options"
    optionLabel="name"
    emptyFilterMessage="Keine Resultaten gefunden"
    panelClass="bluedropdown"
    :ariaLabelledBy="csvFile"
    :inputId="csvFile"
    :placeholder="placeholder"
    :filter="filter"
    :loading="loading"
    :showClear="showClear"
    @change="$emit('update:modelValue', input)"
  >
    <template #option="slotProps">
      <div v-if="slotProps.option.headerOption" class="option headerOption">
        <span>{{ slotProps.option.name }}</span>
      </div>
      <div v-else class="option normalOption">
        <span>{{ slotProps.option.name }}</span>
      </div>
    </template>
  </Dropdown>
</template>

<script>
import Dropdown from "primevue/dropdown";
import getCSV from "@/composables/getCSV";
import appConf from "@/config/config";
import { ref, watch, onMounted } from "vue";

export default {
  components: { Dropdown },
  props: [
    "modelValue",
    "placeholder",
    "label",
    "csvFile",
    "selectFirst",
    "filter",
    "infolink",
    "optionsIn",
    "showClear",
    "input",
    "clear",
    "loadVar",
    "preselect",
  ],
  emits: ["update:modelValue", "load-change"],
  setup(props, { emit }) {
    const input = ref(props.input);
    const loading = ref(true);

    //Fed by CSV
    if (props.csvFile) {
      const { load, retAr: options } = getCSV(props.csvFile);
      load(() => {
        // If select First
        if (props.selectFirst) {
          input.value = options.value[0];
          emit("update:modelValue", input);
        }

        // if preselect
        if (props.preselect) {
          options.value.forEach((el, i) => {
            if (
              el.name == appConf.searchParams.get("ag") 
              &&
              appConf.searchParams.get("ag") !== "Psychotherapie"
            ) {
              input.value = options.value[i];
              emit("update:modelValue", input);
            }
          });
        }

        watch(
          () => props.clear,
          (selection, prevSelection) => {
            if (selection !== prevSelection && props.selectFirst) {
              input.value = options.value[0];
              emit("update:modelValue", input);
            }
          }
        );

        loading.value = false;
        emit("load-change", props.loadVar, false);
      });
      return { options, input, loading };

      //Fed By options
    } else {
      const options = ref(props.optionsIn);
      // if select first
      if (props.selectFirst) {
        input.value = options.value[0];
        emit("update:modelValue", input);
      }
      // if preselect
      if (props.preselect) {
        options.value.forEach((el, i) => {
          if (
            el.name == appConf.searchParams.get("ag") 
            &&
            appConf.searchParams.get("ag") !== "Psychotherapie"
          ) {
            input.value = options.value[i];
            emit("update:modelValue", input);
          }
        });
      }

      watch(
        () => props.clear,
        (selection, prevSelection) => {
          if (selection !== prevSelection && props.selectFirst) {
            input.value = options.value[0];
            emit("update:modelValue", input);
          }
        }
      );
      loading.value = false;
      return { options, input, loading };
    }
  },
};
</script>

<style>
</style>